import PosthogService from '~/services/posthog/PosthogService';

export interface ITodayShiftInviteClickedPayload {
  shiftId: string;
}

/**
 * Fires when the user clicks "Invite" from the Today shift view
 * Event: dental_portal:today_shift:invite_clicked
 */
export function fireTodayShiftInviteClicked(payload: ITodayShiftInviteClickedPayload): void {
  PosthogService.getInstance().track('dental_portal:today_shift:invite_clicked', {
    shift_id: payload.shiftId,
  });
}
